<template>
  <div class="header delay300 fadeInDown" :class="{lan_En : lan != 'zh', lan_Ru: (lan == 'ru' || lan == 'vn' || lan == 'ja')}">
    <div class="meau">
      <div class="content">
        <div class="meau-section">
          <div class="left-menu">
            <div class="menu-toggle" :class="{active: leftMenuOpen}">
              <img class="logo" src="../assets/logo.png" alt="deeplink logo" @click="linkHref('/')">
            </div>
            <div class="dropdown-menu" :class="{ 'open': leftMenuOpen }">
              <el-scrollbar max-height="60vh">
                <div class="menu-item" @click="toggleSubMenu('use')">
                  <span>{{$t('meau.nav1')}}</span>
                  <img class="icon2" src="../assets/arrow.png" alt="">
                </div>
                <div class="submenu" :class="{ 'open': subMenus.use }">
                  <div class="submenu-item" @click="linkHref('/buyGpuServer')">
                    <span>{{$t('meau.nav1_1')}}</span>
                  </div>
                  <div class="submenu-item" @click="linkHref('/getReward')">
                    <span>{{$t('meau.nav1_2')}}</span>
                  </div>
                  <div class="submenu-item" @click="linkHref('/voteReward')">
                    <span>{{$t('meau.nav1_3')}}</span>
                  </div>
                  <div class="submenu-item" @click="linkHref('/gpuMiner')">
                    <span>{{$t('meau.nav1_4')}}</span>
                  </div>
                  <div class="submenu-item" @click="linkHref('/applyCouncil')">
                    <span>{{$t('meau.nav1_5')}}</span>
                  </div>
                  <div class="submenu-item" @click="linkHref('/councilVoting')">
                    <span>{{$t('meau.nav1_6')}}</span>
                  </div>
                  <div class="submenu-item" @click="linkHref('/referenda')">
                    <span>{{$t('meau.nav1_7')}}</span>
                  </div>
                </div>
                <div class="menu-item" @click="toggleSubMenu('learn')">
                  <span>{{$t('meau.nav2')}}</span>
                  <img class="icon2" src="../assets/arrow.png" alt="">
                </div>
                <div class="submenu" :class="{ 'open': subMenus.learn }">
                  <div class="submenu-item" @click="linkHref('/learnDBC')">
                    <span>{{$t('meau.nav2_1')}}</span>
                  </div>
                  <div class="submenu-item" @click="linkHref('/whatisGPU')">
                    <span>{{$t('meau.nav2_2')}}</span>
                  </div>
                  <div class="submenu-item" @click="linkHref('/historyDBC')">
                    <span>{{$t('meau.nav2_3')}}</span>
                  </div>
                  <div class="submenu-item" @click="linkHref('/Whitepaper')">
                    <span>{{$t('meau.nav2_4')}}</span>
                  </div>
                  <div class="submenu-item" @click="linkHref('/WiKi')">
                    <span>{{$t('meau.nav5')}}</span>
                  </div>
                  <div class="submenu-item" @click="linkHref('/introDBC')">
                    <span>{{$t('meau.nav2_5')}}</span>
                  </div>
                </div>
                
                <div class="menu-item" @click="toggleSubMenu('ai')">
                  <span>{{$t('meau.nav9')}}</span>
                  <img class="icon2" src="../assets/arrow.png" alt="">
                </div>
                <div class="submenu" :class="{ 'open': subMenus.ai }">
                  <div class="submenu-item" @click="linkHref('/whatisAi')">
                    <span>{{$t('meau.nav9_1')}}</span>
                  </div>
                  <div class="submenu-item" @click="linkHref('/developAi')">
                    <span>{{$t('meau.nav9_2')}}</span>
                  </div>
                  <div class="submenu-item" @click="linkHref('/deployToken')">
                    <span>{{$t('meau.nav9_3')}}</span>
                  </div>
                  <div class="submenu-item" @click="linkHref('/paymentRelated')">
                    <span>{{$t('meau.nav9_4')}}</span>
                  </div>
                  <div class="submenu-item" @click="linkHref('/gpuMining')">
                    <span>{{$t('meau.nav9_5')}}</span>
                  </div>
                  <div class="submenu-item" @click="linkHref('/developAIModel')">
                    <span>{{$t('meau.nav9_6')}}</span>
                  </div>
                  <div class="submenu-item" @click="linkHref('/fullProcessTesting')">
                    <span>{{$t('meau.nav9_7')}}</span>
                  </div>
                  <div class="submenu-item" @click="linkHref('/primaryProcessTesting')">
                    <span>{{$t('meau.nav9_8')}}</span>
                  </div>
                </div>
                
                <div class="menu-item" @click="toggleSubMenu('miner')">
                  <span>{{$t('meau.nav10')}}</span>
                  <img class="icon2" src="../assets/arrow.png" alt="">
                </div>
                <div class="submenu" :class="{ 'open': subMenus.miner }">
                  <div class="submenu-item" @click="linkHref('/participateDBCMining')">
                    <span>{{$t('meau.nav10_1')}}</span>
                  </div>
                  <div class="submenu-item" @click="linkHref('/participateDBCDLCMining')">
                    <span>{{$t('meau.nav10_2')}}</span>
                  </div>
                  <div class="submenu-item" @click="linkHref('/participateDBCAiMining')">
                    <span>{{$t('meau.nav10_3')}}</span>
                  </div>
                  <div class="submenu-item" @click="linkHref('/participateAiMining')">
                    <span>{{$t('meau.nav10_4')}}</span>
                  </div>
                  <div class="submenu-item" @click="linkHref('/participateGPUMining')">
                    <span>{{$t('meau.nav10_5')}}</span>
                  </div>
                </div>
                <div class="menu-item" @click="toggleSubMenu('wallet')">
                  <span>{{$t('meau.nav4')}}</span>
                  <img class="icon2" src="../assets/arrow.png" alt="">
                </div>
                <div class="submenu" :class="{ 'open': subMenus.wallet }">
                  <div class="submenu-item" @click="linkHref('/createwallet')">
                    <span>{{$t('meau.nav4_1')}}</span>
                  </div>
                  <div class="submenu-item" @click="linkHref('/polkaWallet')">
                    <span>{{$t('meau.nav4_2')}}</span>
                  </div>
                  <div class="submenu-item" @click="linkHref('/mathWallet')">
                    <span>{{$t('meau.nav4_4')}}</span>
                  </div>
                  <div class="submenu-item" @click="linkHref('/ImToken')">
                    <span>{{$t('meau.nav4_5')}}</span>
                  </div>
                  <div class="submenu-item" @click="linkHref('/TrustWallet')">
                    <span>{{$t('meau.nav4_6')}}</span>
                  </div>
                  <div class="submenu-item" @click="linkHref('/metaMask')">
                    <span>{{$t('meau.nav4_7')}}</span>
                  </div>
                </div>
              </el-scrollbar>
            </div>  
          </div>
        </div>
        <div class="right-buttons">
          
          <a class="btn" href="https://dbc.subscan.io/" target="_blank">{{$t('meau.nav8')}}</a>
          <div class="btn" :class="{active: href == '/buyDBC'}" @click="linkHref('/buyDBC')">{{$t('meau.nav6')}}</div>
          <div class="btn_nav1" :class="{active: leftMenuOpen}" @click="toggleLeftMenu"></div>
          <div class="nav2">
            <el-dropdown popper-class="demo-dropdown" @command="handleCommand">
              <img class="icon1" src="../assets/country.png" alt="">
              <template #dropdown>
                <el-dropdown-menu>
                  <el-dropdown-item command="en">ENGLISH</el-dropdown-item>
                  <el-dropdown-item command="zh">简体中文</el-dropdown-item>
                  <el-dropdown-item command="ko">한국어</el-dropdown-item>
                  <el-dropdown-item command="ja">日本語</el-dropdown-item>
                  <el-dropdown-item command="ru">Русский</el-dropdown-item>
                  <el-dropdown-item command="vn">Việt nam</el-dropdown-item>
                </el-dropdown-menu>
              </template>
            </el-dropdown>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  // @ is an alias to /src
  import { defineComponent, ref, onMounted ,computed, watch} from "vue";
  import { useI18n } from "vue-i18n";
  import { useRoute, useRouter } from 'vue-router'
  import { useStore } from "vuex"
  export default defineComponent({
    name: 'ComponentHeader',
    setup() {
      const { t, locale } = useI18n()
      const router = useRouter()
      const route = useRoute()
      const store = useStore()
      let lan = computed(() => store.state.lan)
      const ishover = ref(false)
      const lanObj = {
        'en': 'ENGLISH',
        'ko': '한국어',
        'zh': '简体中文',
        'ja': '日本語',
        'ru': 'Русский',
        'vn': 'Việt nam'
      }
      const href = ref('/')
      const handleCommand = (command) => {
        locale.value = command
        localStorage.setItem('lan', command)
        store.commit('changeLan', command)
        drawer1.value = false
      }
      const change = (el) => {
        ishover.value = el
      }
      const linkHref = (el) => {
        if (el == '/Whitepaper') {
          if (lan.value == 'zh') {
            window.open('/DeepBrainChainWhitepaper_zh.pdf');
          } else {
            window.open('/DeepBrainChainWhitepaper_en.pdf');
          }
          return
        } else if(el == '/WiKi') {
          window.open('https://deepbrainchain.github.io/DBC-Wiki/');
          return
        }
        router.push({path: el})
        href.value = el
        localStorage.setItem('path', el)
        store.commit('changePath', el)
      }
      const linkHref2 = (command) => {
        if (command == '/Whitepaper') {
          if (lan.value == 'zh') {
            window.open('/DeepBrainChainWhitepaper_zh.pdf');
          } else {
            window.open('/DeepBrainChainWhitepaper_en.pdf');
          }
          return
        } else if(command == '/WiKi') {
          window.open('https://deepbrainchain.github.io/DBC-Wiki/');
          return
        }
        router.push({path: command})
        href.value = command
        localStorage.setItem('path', command)
        store.commit('changePath', command)
      }
      const drawer = ref(false)
      const drawer1 = ref(false)
      const drawer2 = ref(false)
      const linkHref1 = () => {
        drawer.value = true
      }
      const openDraw2 = () => {
        drawer.value = false
        drawer2.value = true
      }
      const isPc = () => {
        if(window.navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)) {
          return true; // 移动端
        }else{
          return false; // PC端
        }
      }

      const leftMenuOpen = ref(false);
      const rightMenuOpen = ref(false);
      const selectedItem = ref('无');
      
      const subMenus = ref({
        use: false,
        learn: false,
        ai:false,
        miner:false,
        wallet:false
      });
      
      const toggleLeftMenu = () => {
        leftMenuOpen.value = !leftMenuOpen.value;
        console.log(leftMenuOpen.value, 'leftMenuOpen.value');
        // 关闭右侧菜单当打开左侧菜单时
        if (leftMenuOpen.value) {
          rightMenuOpen.value = false;
        }
      };
      
      const toggleRightMenu = () => {
        rightMenuOpen.value = !rightMenuOpen.value;
        // 关闭左侧菜单当打开右侧菜单时
        if (rightMenuOpen.value) {
          leftMenuOpen.value = false;
        }
      };
      
      const toggleSubMenu = (menu) => {
        subMenus.value[menu] = !subMenus.value[menu];
      };
      
      const selectItem = (item) => {
        selectedItem.value = item;
        // 选择项目后关闭所有菜单
        leftMenuOpen.value = false;
        rightMenuOpen.value = false;
      };
      
      // 点击页面其他区域关闭菜单
      document.addEventListener('click', (e) => {
        if (!e.target.closest('.left-menu') && !e.target.closest('.right-buttons')) {
          leftMenuOpen.value = false;
          rightMenuOpen.value = false;
        }
      });

      const isphone = ref(false)
      onMounted(() => {
        href.value = store.state.path
        isphone.value = isPc()
      });
      watch(lan, (newValue) => {
        
      })
      return {
        lan,
        ishover,
        href,
        isphone,
        handleCommand,
        change,
        linkHref,
        drawer,
        linkHref1,
        linkHref2,
        drawer1,
        drawer2,
        openDraw2,
        leftMenuOpen,
        rightMenuOpen,
        selectedItem,
        subMenus,
        toggleLeftMenu,
        toggleRightMenu,
        toggleSubMenu,
        selectItem
      };
    }
  })
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.header {
  position: fixed;
  z-index: 10;
  width: 100%;
  font-style: normal;
  -webkit-backdrop-filter: blur(10px);
  backdrop-filter: blur(10px);
  background: hsla(0, 0%, 100%, 0);
  // font-family: "Noto Sans SC";
  .meau {
    width: 1200px;
    margin: auto;
    height: 80px;
    // background: #060607;
    .content {
      width: 100%;
      height: 80px;
      margin: auto;
      display: flex;
      font-size: 18px;
      color: #899AA9;
      align-items: center;
      box-sizing: border-box;
      justify-content: space-between;
      .meau-section {
        justify-content: space-between;
        margin: 10px 0;
        .left-menu {
          display: flex;
          position: relative;
          height: 100%;
          .menu-toggle {
            height: 100%;
            display: flex;
            cursor: pointer;
            color: #b8c2cc;
            padding: 10px 20px;
            align-items: center;
            border-radius: 7px 7px 0 0;
            transition: background 0.3s;
            &.active {
              background: #252525;
            }
          }
          .dropdown-menu {
            width: 257px;
            position: absolute;
            top: 52px;
            left: 0;
            z-index: 10;
            padding: 10px 0;
            background: #252525;
            border-radius: 0 0 7px 7px;
            backdrop-filter: blur(15px);
            z-index: 100;
            opacity: 0;
            visibility: hidden;
            transform: translateY(-10px);
            transition: all 0.3s ease;
            &.open {
              opacity: 1;
              visibility: visible;
              transform: translateY(0);
            }
          }
          .menu-item {
            padding: 12px 20px;
            cursor: pointer;
            transition: background 0.3s;
            display: flex;
            align-items: center;
            justify-content: space-between;
            &:hover {
              background: rgba(76, 201, 240, 0.1);
            }
          }
          .submenu {
            max-height: 0;
            overflow: hidden;
            transition: max-height 0.3s ease;
            .submenu-item {
              padding: 10px 20px;
              cursor: pointer;
              transition: background 0.3s;
              font-size: 14px;
              color: #b8c2cc;
              display: flex;
              align-items: center;
              span {
                padding-left: 20px;
              }
            }
            
            .submenu-item:hover {
              background: rgba(76, 201, 240, 0.05);
              color: #fff;
            }
          }
          
          .submenu.open {
            max-height: 500px;
          }
        }
      }
      .right-buttons {
        display: flex;
        gap: 15px;
      }
      .btn_nav1 {
        cursor: pointer;
        width: 72px;
        height: 54px;
        transition: all .3s;
        background: url(../assets/new_home/expand.png) no-repeat 100%/100%;
        &.active {
          width: 54px;
          height: 54px;
          background: url(  ../assets/new_home/close.png) no-repeat 100%/100%;
        }
      }
      .btn {
        color: #fff;
        display: flex;
        cursor: pointer;
        font-size: 16px;
        padding: 12px 24px;
        border-radius: 16px;
        align-items: center;
        transition: all 0.3s;
        text-decoration: none;
        background: rgba(255, 255, 255, 0.05);
        border: 1px solid rgba(255, 255, 255, 0.1);
        &:hover {
          color: #000;
          background: rgba(255, 255, 255, 1);
        }
        &.active {
          color: #000;
          background: rgba(255, 255, 255, 1);
        }
      }
      
      .nav2 {
        cursor: pointer;
        display: flex;
        align-items: center;
        font-weight: 500;
        color: #FFFFFF;
        &:hover {
          color: #FFFFFF;
        }
        .el-dropdown {
          font-weight: 500;
          color: #FFFFFF;
          margin: 0 5px;
          font-family: 'Rubik, sans-serif';
        }
        .icon1 {
          width: 24px;
          height: 24px;
        }
        .icon2 {
          width: 10px;
          height: 6px;
        }
      }
      
      .logo {
        width: 217px;
        height: 28px;
        cursor: pointer;
      }
      .nav {
        display: flex;
        align-items: center;
        .nav1 {
          cursor: pointer;
          display: block;
          color: rgba(255, 255, 255, 0.6);
          margin-right: 40px;
          text-decoration: none;
          &.active {
            color: #FFFFFF;
            font-weight: 600;
          }
          &:hover {
            color: #FFFFFF;
            font-weight: 600;
          }
          .el-dropdown-link {
            font-size: 16px;
            &.active {
              color: #FFFFFF;
            }
          }
        }
        .nav_new {
          cursor: pointer;
          display: flex;
          font-weight: 500;
          margin-right: 50px;
          align-items: center;
          &:hover {
            color: #FFFFFF;
          }
          .el-dropdown {
            font-weight: 500;
            margin: 0 5px;
            font-size: 16px;
            color: rgba(255, 255, 255, 0.6);
            font-family: 'Rubik, sans-serif';
            &:hover {
              // font-weight: 600;
              color: #FFFFFF;
            }
            &.active {
              color: #FFFFFF;
              // font-weight: 600;
            }
          }
          .icon1 {
            width: 20px;
            height: 20px;
          }
          .icon2 {
            width: 10px;
            height: 6px;
          }
        }
        .nav2 {
          cursor: pointer;
          display: flex;
          align-items: center;
          font-weight: 500;
          color: #FFFFFF;
          &:hover {
            color: #FFFFFF;
          }
          .el-dropdown {
            font-weight: 500;
            color: #FFFFFF;
            margin: 0 5px;
            font-family: 'Rubik, sans-serif';
          }
          .icon1 {
            width: 20px;
            height: 20px;
          }
          .icon2 {
            width: 10px;
            height: 6px;
          }
        }
      }
    }
  }
}

.lan_Ru.header {
  .meau {
    .content {
      .nav {
        .nav_new {
          margin-right: 25px;
          .el-dropdown {
            font-size: 14px;
          }
        }
      }
    }
  }
}
</style>

<style lang="scss">
.drawerInfo {
  height: initial !important;
  border-radius: 20px 20px 0 0;
  .el-drawer__body {
    padding: 0;
  }
  .meauInfo {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    .meaulist {
      width: 100%;
      cursor: pointer;
      padding: 20px 0;
      font-size: 34px;
      font-weight: 400;
      text-align: center;
      text-decoration: none;
      color: rgba(54, 63, 94, 0.6);
      &.active {
        font-weight: 600;
        color: #363F5E;
        background: rgba(54, 63, 94, 0.08);
      }
      &:hover {
        font-weight: 600;
        color: #363F5E;
        background: rgba(54, 63, 94, 0.08);
      }
    }
  }
  .iconInfo {
    width: 100%;
    padding: 50px 20px;
    background: #eee;
    .title {
      font-size: 34px;
      color: #363F5E;
      font-weight: 600;
      line-height: 48px;
      text-align: center;
      margin-bottom: 40px;
    }
    .community {
      width: 100%;
      .follow {
        width: 90%;
        margin: auto;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: center;
        .list {
          margin: 0 20px 10px;
          cursor: pointer;
          font-size: 12px;
          line-height: 14px;
          text-align: center;
          color: rgba(54, 63, 94, 0.6);
          p {
            display: flex;
            align-items: center;
            justify-content: center;
            margin-bottom: 5px;
            img {
              width: 20px;
              margin: 0 5px;
            }
          }
          span {
            width: 80px;
            height: 80px;
            margin-bottom: 5px;
            display: inline-block;
            
          }
          &:hover {
            color: #363F5E;
            span {
              
            }
          }
        }
      }
    }
  }
}
</style>
